import { Text } from "@mantine/core"

interface InfoRowProps {
  label: string
  children: React.ReactNode
}

export default function InfoRow({ label, children }: InfoRowProps) {
  return (
    <div>
      <Text size="xs" tt="uppercase" fw={600} c="dimmed" lts="0.05em" mb={2}>
        {label}
      </Text>
      {children}
    </div>
  )
}
